/**
 * Test Results
 */
 $(document).on("ready", function () {
     $(document).on('click','#summaryWrap .learningstyle #save',function(e){
         e.preventDefault();
         var autoAddSkills=null;
         var $svbtn=$(this);
         if($svbtn.hasClass('disabled')){ return; }
         $svbtn.prop('disabled',true).addClass('disabled');
         var $cur=$('form');
         saveAssessment($cur);
     });
     if($('#trForm').length && !$('#trForm .fromSave').length){
         saveAssessment($('form'));
     }
		function saveAssessment($cur){
            $.ajax({
                type: "POST",
                url: '/wp-admin/admin-ajax.php',
                data: 'action=fw_saveAssessment&'+$cur.serialize(), // serializes the form's elements.
                dataType: 'json',
                success: function (data) {
                    //$svbtn.prop('disabled', false).removeClass('disabled');
                    if (data[0] === 'success') {
                        //console.log(data.length);
                        if (data.length > 1) {
                            $('#remove').val(data[1]);
                            if(!$('#save').length){
                                $('#text').append('<div class="remove-results"><p class=""><a href="#" class="btn primary  fromSave" id="save">REMOVE YOUR RESULTS</a></p></div>');
                            }else{

                            }
                            return;
                            $('#save').text('REMOVE YOUR RESULTS');
                        } else {
                            //console.log(data.length);
                            window.location = wp_vars.home + "/self-discovery/";
                        }
                    } else if (data.errors.length > 0) {
                        for (var i = 0; i < data.errors.length; i++) {
                            $cur.children('.errors').append('<p class="error">' + data.errors[i] + '</p>');
                        }
                    } else {
                        $cur.children('.errors').append('<p class="error">' + data + '</p>');
                    }
                },
                error: function () {
                }
            });
        }

     $('#testResults .more a,.interest-descriptions .more a,.value-descriptions .more a').on('click',function(e){
         e.preventDefault();
         //$('#overlay').remove();
         //$('body').append('<div id="overlay" class="test-result"></div>');
         //$('#overlay').append('<div id="olWrap">');
         //$('#olWrap').append($('#'+$(this).attr('data-for')).clone());
         addOverlay('test-result',$('#'+$(this).attr('data-for')).clone());
     });
     $('.assessment-descriptions__block .header').on('click',function(e){
        e.preventDefault();
        let $this=$(this).closest('.assessment-descriptions__block');
        if($this.hasClass('collapsed')){
            $this.removeClass('collapsed').addClass('expanded');
            $this.attr('aria-expanded', 'true');
        }else if($this.hasClass('expanded')){
            $this.removeClass('expanded').addClass('collapsed');
            $this.attr('aria-expanded', 'false');
        }
     });
		$('#skills .title').on('click',function(){
            $('#overlay').remove();
            $('body').append('<div id="overlay" class="test-result"></div>');
            $('#overlay').append('<div id="olWrap">');
			$.ajax({
				   type: "POST",
				   url: '/wp-admin/admin-ajax.php',
				   data: {action:'fw_skillsPopup_ajax',which:$(this).attr('data-for')}, // serializes the form's elements.
				   success: function(data)
				   {
						   $('#olWrap').append(data);
				   },
				   error: function(){
				   }
			});
		});
    $('#test_link').on('click',function(e){
      window.location = $('#test_link').attr('href');
    });
		$('.add-skills').on('click',function(e){
            e.preventDefault();
            var skills=[];
            $('.tr.most .title').each(function(){
                skills.push($(this).data('for'));
            });
		   addWaiting();
            $.ajax({
                type: "POST",
                url: '/wp-admin/admin-ajax.php',
                data: {action:'fw_assessment_add_skills_ajax',skills:skills}, // serializes the form's elements.
                success: function(data)
                {
                    addOverlay('add-skills',data);
                    removeWaiting();
                    $('#overlay .skill-list__skill').on('click',function(e){
                        e.preventDefault();
                        $(this).remove();
                    });
                    $('#overlay .update-skills').on('click',function(){
                        addWaiting();
                        $.ajax({
                            type: "POST",
                            url: '/wp-admin/admin-ajax.php',
                            data: 'action=fw_update_skills_ajax&'+$(this).closest('form').serialize(), // serializes the form's elements.
                            success: function(data)
                            {
                                console.log({data});
                                if(data=='success'){
                                    $('#overlay').remove();
                                    removeWaiting();
                                    return;
                                }
                                addOverlay('add-skills',data);
                                removeWaiting();
                            },
                            error: function(){
                            }
                        });
                    });
                },
                error: function(){
                }
            });
        });
});
function removeWaiting(){
  $('#waiting').remove();
}
